<template>
  <div>
    <v-btn icon elevation="0" @click.stop="openMenu" small>
      <v-icon>bhi-more-square</v-icon>
    </v-btn>
    <v-menu
      rounded
      absolute
      offset-x
      transition="false"
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
    >
      <v-list class="notifications__more--menu">
        <v-list-item link dense @click="$emit('markAsRead', id, unread)">
          <v-list-item-icon>
            <v-icon>bhi-double-check</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              {{ !unread ? 'Mark as read' : 'Mark as unread' }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item link dense @click.stop="expandMoreMenu">
          <v-list-item-icon>
            <v-icon>bhi-clock</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Remind me later
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon>bhi-chevron-down</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-expand-transition>
          <div v-if="showContextMenu" class="notifications__more--menu-context">
            <v-list-item
              class="notifications__more--menu-item"
              @click="$emit('remindMeTomorrow', id, unread, tomorrow)"
            >
              <div class="notifications__more--menu-item__wrapper">
                <span class="notifications__more--menu-item__title">
                  Tomorrow
                </span>
                <span class="notifications__more--menu-item__time">
                  {{ this.tomorrowDay.name }} {{ this.tomorrowDay.time }}
                </span>
              </div>
            </v-list-item>
            <v-list-item
              class="notifications__more--menu-item"
              @click="$emit('remindMeNextWeek', id, unread, nextWeek)"
            >
              <div class="notifications__more--menu-item__wrapper">
                <span class="notifications__more--menu-item__title">
                  Next week
                </span>
                <span class="notifications__more--menu-item__time">
                  {{ this.nextWeekDay.name }} {{ this.nextWeekDay.time }}
                </span>
              </div>
            </v-list-item>
            <v-list-item
              class="notifications__more--menu-item"
              @click="$emit('remindMeAfterTenDays', id, unread, afterTenDays)"
            >
              <div class="notifications__more--menu-item__wrapper">
                <span class="notifications__more--menu-item__title">
                  10 days
                </span>
                <span class="notifications__more--menu-item__time">
                  {{ this.afterTenDaysDay.name }}
                  {{ this.afterTenDaysDay.time }}
                </span>
              </div>
            </v-list-item>
            <v-list-item
              class="notifications__more--menu-item"
              @click="$emit('toggleShowDatePickerHandler')"
            >
              <div class="notifications__more--menu-item__wrapper">
                <span class="notifications__more--menu-item__title">
                  Select date
                </span>
              </div>
            </v-list-item>
          </div>
        </v-expand-transition>
      </v-list>
    </v-menu>
  </div>
</template>
<script>
export default {
  name: 'NotificationsMoreMenu',
  components: {},
  props: {
    id: {
      type: Number,
      default: 0,
    },
    unread: {
      type: Boolean,
      default: false,
    },
    tomorrow: {
      type: String,
      default: '',
    },
    nextWeek: {
      type: String,
      default: '',
    },
    afterTenDays: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      x: 0,
      y: 0,
      showMenu: false,
      showContextMenu: false,
      tomorrowDay: {
        name: this.$moment()
          .add(1, 'days')
          .format('ddd'),
        time: '12:00',
      },
      nextWeekDay: {
        name: this.$moment()
          .add(7, 'days')
          .format('ddd'),
        time: '12:00',
      },
      afterTenDaysDay: {
        name: this.$moment()
          .add(10, 'days')
          .format('ddd'),
        time: '12:00',
      },
    }
  },
  computed: {},
  methods: {
    openMenu(e) {
      e.stopPropagation()
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },
    closeMenu() {
      this.showMenu = false
    },
    expandMoreMenu(e) {
      e.stopPropagation()
      this.$nextTick(() => {
        this.showContextMenu = !this.showContextMenu
      })
    },
  },
}
</script>

<style lang="scss">
.notifications {
  &__more {
    width: 32px;
    flex-shrink: 0;
    text-align: center;
    position: absolute;
    top: 4px;
    right: 0;
    opacity: 0;
    -webkit-transition-duration: 150ms;
    -moz-transition-duration: 150ms;
    -ms-transition-duration: 150ms;
    -o-transition-duration: 150ms;
    transition-duration: 150ms;
    .v-btn {
      padding: 0;
      background: $bh-blue--4;
      .v-icon {
        color: $bh-blue--3;
      }
      &:hover,
      &:focus {
        .v-icon {
          color: $bh-blue;
        }
      }
    }
    &--menu {
      width: 260px;
      .v-list-item__icon {
        margin-right: 12px !important;
        text-align: center;
        display: block;
        .v-icon {
          color: $bh-blue;
        }
      }
      .v-list-item__title {
        font-weight: bold;
        font-size: 1rem;
        color: $bh-blue;
      }
    }

    &--menu-context {
      background-color: $bh-new-gray;
    }
    &--menu-item {
      padding: 0 12px;
      transition: background-color 0.3s ease-in;
      cursor: pointer;
      &.v-list-item {
        &--link:before {
          background-color: inherit;
        }
      }
      &:hover {
        background-color: $bh-white;
      }
      &__wrapper {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 0 24px 0 40px;
      }
      &__title {
        font-size: 1rem;
        font-weight: 700;
        color: $bh-gray--1;
      }
      &__time {
        font-size: 1rem;
        font-weight: 400;
        color: $bh-gray--2;
      }
    }
  }
}
</style>
